import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import type { IntegrationKind } from './types';

interface Props {
  kind: IntegrationKind;
  onKind: (k: IntegrationKind) => void;
}

export function Step1Kind({ kind, onKind }: Props) {
  return (
    <FormControl>
      <Typography variant="subtitle2" gutterBottom>
        What kind of integration is this?
      </Typography>
      <RadioGroup value={kind} onChange={(e) => onKind(e.target.value as IntegrationKind)}>
        <FormControlLabel
          value="booking"
          control={<Radio />}
          label="Booking system (Ventrata, FareHarbor, Bokun, TourCMS, Rezdy…)"
        />
        <FormControlLabel
          value="fleet"
          control={<Radio />}
          label="Vehicle tracking system (Quartix)"
        />
      </RadioGroup>
    </FormControl>
  );
}
